export const loading = () => ({ data: null, isLoading: true, error: null });
export const loaded = (data) => ({ data: data, isLoading: false, error: null });
export const error = (e) => ({ data: null, isLoading: false, error: e });

export interface Loadable<T> {
  data: T;
  isLoading: boolean;
  error: any;
}
